import { Flex } from '@iheartjane/reefer';
import { Form, useFormContext } from '@iheartjane/reefer-hook-form';
import { useEffect } from 'react';
import { useWatch } from 'react-hook-form';

import { useGlobalSpecialsModal } from '@jane/business-admin/providers/GlobalSpecialsModalProvider';

export const DiscountTypeAndDiscountAmountField = () => {
  const { getValues, trigger } = useFormContext();
  const discountTypeValue = getValues('discount_type');
  const specialTypeValue = getValues('special_type');
  const { isDisabled } = useGlobalSpecialsModal();

  const specialTypeWatch = useWatch({ name: 'special_type' });
  const specialType = specialTypeWatch || specialTypeValue;

  const hasTargetPriceOption = [
    'product',
    'bundle',
    'bulk_pricing',
    'spending_threshold',
  ].includes(specialType);
  const discountTypeWatch = useWatch({ name: 'discount_type' });

  const isBulkPricing =
    (specialTypeWatch || specialTypeValue) === 'bulk_pricing';
  const isPercentOrDollar = ['percent', 'dollar_amount'].includes(
    discountTypeWatch || discountTypeValue
  );
  const discountAmountLabel =
    isBulkPricing && isPercentOrDollar
      ? 'Discount amount per product'
      : 'Discount amount';

  useEffect(() => {
    // Need to run validation if the user selects Dollars or Target Price first
    // then enters in a value > 100 and switches to Percentage
    if (discountTypeValue === 'percent') trigger('discount_percent');
  }, [discountTypeValue, trigger]);

  const discountTypes = [
    { label: 'Percentage (%)', value: 'percent' },
    { label: 'Dollars ($)', value: 'dollar_amount' },
    ...(hasTargetPriceOption
      ? [{ label: 'Target Price', value: 'target_price' }]
      : []),
  ];

  return (
    <Flex gap={24} justifyContent="space-between" width="100%">
      <Form.SelectField
        name="discount_type"
        label="Discount type"
        helperText={
          hasTargetPriceOption
            ? 'Target price applies to entire discounted group, not each item'
            : ''
        }
        options={discountTypes}
        required
        width="50%"
        disabled={isDisabled}
      />

      <Form.NumberField
        name={`discount_${discountTypeValue}`}
        label={discountAmountLabel}
        required
        width="50%"
        min={0}
        disabled={isDisabled}
        startUnit={
          ['dollar_amount', 'target_price'].includes(discountTypeValue)
            ? '$'
            : undefined
        }
        endUnit={discountTypeValue === 'percent' ? '%' : undefined}
        validate={(value: number) => {
          return discountTypeValue === 'percent' && value > 100
            ? 'Discount amount cannot exceed 100'
            : true;
        }}
        disableOnWheel
      />
    </Flex>
  );
};
